export default "__VITE_ASSET__5f19a722__"